import { Input } from "@/components/ui";
import { cn } from "@/shared/util/cn";

interface SearchFieldProps {
  placeholder: string;
  value: string;
  setSearchValue: (value: string) => void;
  className?: string;
}

const SearchField = (props: SearchFieldProps) => {
  const { placeholder, value, setSearchValue, className } = props;

  return (
    <div className={cn("relative w-full", className)}>
      <Input
        type="search"
        placeholder={placeholder}
        value={value}
        onChange={(e) => setSearchValue(e.target.value)}
        className="w-full"
      />
    </div>
  );
};

export default SearchField;
